import "animate.css";
import { useMemo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import profileImage from "../assets/img/banner profile.jpg";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [, setIndex] = useState(1);
  const toRotate = useMemo(
    () => ["Web Developer", "Frontend Developer", "UI Designer"],
    [],
  );
  const period = 200;

  useEffect(() => {
    const tick = () => {
      let i = loopNum % toRotate.length;
      let fullText = toRotate[i];
      let updatedText = isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1);

      setText(updatedText);

      if (isDeleting) {
        setDelta((prevDelta) => prevDelta / 2);
      }

      if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setIndex((prevIndex) => prevIndex - 1);
        setDelta(period);
      } else if (isDeleting && updatedText === "") {
        setIsDeleting(false);
        setLoopNum((prev) => prev + 1);
        setIndex(1);
        setDelta(200);
      } else {
        setIndex((prevIndex) => prevIndex + 1);
      }
    };

    const ticker = setInterval(tick, delta);
    return () => clearInterval(ticker);
  }, [text, delta, isDeleting, loopNum, toRotate, period]);

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="banner-row align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={`banner-text ${
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }`}
                >
                  <span className="tagline">
                    Willkommen zu meinem Portfolio
                  </span>
                  <h1>
                    {`Hey ich bin Liam`} <br />
                    <span className="txt-rotate">
                      <span className="wrap">{text}</span>
                    </span>
                  </h1>
                  {/*  {t("welcomeText")} */}
                  <p>
                    Ich arbeite als Web-Entwickler seit 2021 und
                    <br />
                    wohne in Deutschland, Bayern.
                    <br />
                    In diesen Bereichen konnte ich schon Erfahrung sammeln:{" "}
                    <br />
                    <span style={{ color: "#2091a5" }}>
                      <b>
                        B2B, Softwaredienstleistung B2C, im Medien-Sektor und{" "}
                        <br /> seit kurzem auch in der Versicherungsbranche.
                      </b>
                    </span>
                  </p>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5} className="banner-image-col">
            <img
              src={profileImage}
              alt="Portrait von Luca Liam Schäfer"
              className="banner-image"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
